import React from "react";

import { PaginationButton } from "@silversea-ssc/ui-components-react";
import * as styles from "./SliderControllers.module.scss";
import { useLingui } from "@lingui/react/macro";
import { sliderLabels } from "components/Slider";

interface SliderControllersProps {
  enabled: boolean;
  prevDisabled: boolean;
  nextDisabled: boolean;
  prevSlide: () => void;
  nextSlide: () => void;
  totalPages: number;
  currentPage: number;
}

const SliderControllers: React.FC<
  React.PropsWithChildren<SliderControllersProps>
> = ({
  prevDisabled,
  nextDisabled,
  prevSlide,
  nextSlide,
  totalPages,
  currentPage
}) => {
  const { t } = useLingui();
  const labels = sliderLabels(t);
  return (
    <React.Fragment>
      {totalPages > 1 && (
        <div className={styles.controls}>
          <div className={styles.buttons}>
            <PaginationButton
              arrow="left"
              disabled={prevDisabled}
              onClick={prevSlide}
              aria-label={t`Previous`}
              dataContentPiece="slider_prev_button"
              role="button"
            />
            <PaginationButton
              arrow="right"
              disabled={nextDisabled}
              onClick={nextSlide}
              aria-label={t`Next`}
              dataContentPiece="slider_next_button"
              role="button"
            />
          </div>
          <div className={styles.pageIndex}>
            {currentPage + 1} {labels.counterSeparator} {totalPages}
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default React.memo(SliderControllers);
